import { t } from '../../i18n.es.js';
import React from 'react';
import { styled, Currency, LazyImage, SvgIcon } from '@teko/ui';
import get from 'lodash.get';
import { PromotionType } from '../../types.es.js';
import { SelectOption } from '../../Common/SelectOption/SelectOption.es.js';
import { PromotionInfo } from './PromotionInfo/PromotionInfo.es.js';

const Quantity = styled.span `
  font-size: 0.75rem;
  color: #848788;
  margin-right: 4px;
`;
const Content = styled.div `
  display: flex;
  justify-content: space-around;
`;
const Benefit = styled.div `
  flex: 1;
  display: flex;
  flex-direction: column;
`;
const Expired = styled.div `
  font-size: 0.75rem;
  color: #f78212;
  margin-left: 8px;
  display: flex;
  align-items: flex-end;
  margin-bottom: 6px;
`;
const Label = styled.div `
  font-size: 0.75rem;
  color: #333333;
  flex: 1;
`;
const Coupon = styled.div `
  text-transform: uppercase;
  padding: 0 6px;
  margin: 0 4px;
  background-color: #ef2741;
  color: #fff;
  border-radius: 2px;
  display: inline-block;
`;
const GiftImage = styled.div `
  width: 10%;
  margin-right: 12px;
`;
const Discount = styled(Currency) `
  color: #ed2101;
  margin-left: 4px;
`;
const StyledPrice = styled(Discount) `
  font-weight: bold;
`;
const PriceWrapper = styled.div `
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;
const GiftWrapper = styled(PriceWrapper) `
  margin-top: 8px;
`;
const PromotionIcon = styled.div `
  width: 10%;
  height: 34px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  border: 1px solid #e0e0e0;
  margin-right: 12px;
`;
const Price = styled.strong `
  color: #ed2101;
`;
const Promotion = ({ promotion, className, active = false, onClick, }) => {
    return (React.createElement(SelectOption, { isActive: active, activeBackground: "rgba(20, 53, 195, 0.08)", onClickOption: () => onClick(promotion.id), className: className },
        React.createElement(Content, null,
            React.createElement(Benefit, null,
                promotion.price && (React.createElement(PriceWrapper, null,
                    React.createElement(Price, null, t('Giá:')),
                    " ",
                    React.createElement(StyledPrice, { value: promotion.price }))),
                promotion.type === PromotionType.PRODUCT ? (React.createElement(React.Fragment, null,
                    promotion.benefit.money &&
                        !!promotion.benefit.money &&
                        promotion.benefit.money.map((moneyPromotion) => (React.createElement(Label, { key: moneyPromotion.id },
                            t('Đã giảm thêm'),
                            React.createElement(Discount, { value: moneyPromotion.money || 0 })))),
                    promotion.benefit.items &&
                        !!promotion.benefit.items &&
                        promotion.benefit.items.map((gift) => {
                            return (React.createElement(GiftWrapper, { key: gift.name },
                                React.createElement(GiftImage, null,
                                    React.createElement(LazyImage, { borderRadius: 2, contain: true, src: get(gift, 'image.src') || '' })),
                                React.createElement(Quantity, null,
                                    "x",
                                    gift.quantity),
                                React.createElement(Label, null, gift.name)));
                        }))) : (React.createElement(GiftWrapper, null,
                    React.createElement(PromotionIcon, null,
                        React.createElement(SvgIcon, { name: "promotion", size: 16, color: "#1435c3" })),
                    React.createElement(Label, null,
                        t('Đã áp dụng mã giảm giá'),
                        React.createElement(Coupon, null,
                            " ",
                            get(promotion, 'condition.coupon'),
                            " "),
                        t('giảm'),
                        React.createElement(PromotionInfo, { money: get(promotion, 'benefit.money.0'), condition: promotion.condition }))))),
            promotion.remainingTime && (React.createElement(Expired, null,
                t('Chỉ còn'),
                " ",
                promotion.remainingTime)))));
};

export { Promotion };
